<template>
    <v-dialog
        v-if="showDialog"
        v-model="showDialog"
        width="60%"
        :persistent="loading"
        :fullscreen="
            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? true : false
        "
        :hide-overlay="
            $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? true : false
        "
    >
        <v-card class="overflow-hidden pt-20">
            <v-toolbar
                dark
                color="primary"
                class="d-flex"
                v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
            >
                <v-btn v-if="!loading" icon @click="handleDialog()" class="mr-1">
                    <fa
                        :icon="['fal', 'arrow-left']"
                        class="fa-lg"
                        style="color: #fff"
                    />
                </v-btn>
                <TranslatableStringComponent :tstring="{string: 'backToOrderDetails'}" />
                <v-spacer></v-spacer>
                <v-btn
                    x-small
                    outlined
                    color="#fff"
                    :disabled="pdfLink && !loading ? false : true"
                    @click="downloadPdf()"
                >
                    <fa :icon="['fal', 'download']" class="fa-sm ml-1" style="color: #fff" />
                    <span><TranslatableStringComponent :tstring="{string: 'download'}" /> {{ filename }}</span>
                </v-btn>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-app-bar
                v-else
                absolute
                color="#00000"
                elevate-on-scroll
                scroll-target="#scrolling-techniques-7"
            >
                <v-toolbar-title class="text-h5">{{
                    filename
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    color="primary"
                    :disabled="pdfLink && !loading ? false : true"
                    @click="downloadPdf()"
                >
                    <fa :icon="['fal', 'download']" class="fa-sm ml-2" />
                    <span><TranslatableStringComponent :tstring="{string: 'download'}" /> {{ filename }}</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!loading" icon @click="handleDialog()">
                    <fa :icon="['fal', 'times']" class="fa-lg" />
                </v-btn>
            </v-app-bar>
            <v-sheet
                id="scrolling-techniques-7"
                class="overflow-y-auto mt-16"
                max-height="85vh"
            >
                <div
                    class="d-flex justify-center align-center"
                    style="height: 80vh"
                >
                    <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="primary"
                    />
                    <v-subheader v-else-if="!pdfLink"
                        ><TranslatableStringComponent :tstring="{string: 'noPdfGenerated'}" /></v-subheader
                    >
                    <iframe
                        v-else
                        :src="pdfLink"
                        width="100%"
                        height="100%"
                    ></iframe>
                </div>
            </v-sheet>
        </v-card>
    </v-dialog>
</template>

<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OrderPdfModal',
    components: {
        TranslatableStringComponent,
    },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showDialog: false,
            pdfLink: '',
            filename: '',
            loading: false,
        }
    },
    methods: {
        handleDialog() {
            this.showDialog = !this.showDialog
        },
        async getPdf() {
            this.loading = true
            try {
                const res = await this.$axios.post('erp-orderPdf?method=read', {
                    orderId: this.order.id,
                })
                this.pdfLink = res?.data?.generatePdfDoc
            } catch (error) {
                console.log(error)
            }
            this.loading = false
        },
        downloadPdf() {
            const a = document.createElement('a')
            a.href = this.pdfLink
            a.target = '_blank';
            a.download = this.filename
            a.click()
        },
    },

    mounted() {
        this.filename = `${this.order.docNo}.pdf`
    },

    // watch for changes in the showDialog state
    watch: {
        showDialog: {
            handler(newVal) {
                if (newVal) {
                    this.getPdf()
                }
            },
        },
    },
}
</script>

<style></style>
